import React from "react";
import { panels } from "../mock";

export default function Panels({ onContact }) {
  const go = (target) => {
    if (target === "contact") return onContact();
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
      {panels.map((p) => (
        <button
          key={p.id}
          onClick={() => go(p.target)}
          className="group relative h-[208px] overflow-hidden md:h-[256px] lg:h-[78vh] lg:min-h-[540px]"
        >
          <img
            src={p.img}
            alt={p.label}
            style={{ objectPosition: p.pos || "center" }}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          {/* Resting overlay + centered label */}
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h3 className="font-sans text-lg font-light uppercase tracking-[0.3em] text-white transition-all duration-500 group-hover:opacity-0 sm:text-xl">
              {p.label}
            </h3>
          </div>

          {/* Hover overlay + detail block */}
          <div className="absolute inset-0 bg-black/55 opacity-0 transition-all duration-500 group-hover:opacity-100" />
          <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center px-4 opacity-0 transition-all duration-500 group-hover:opacity-100 lg:px-8">
            <h3 className="font-sans text-lg font-light uppercase tracking-[0.3em] text-[#F1E6D7] sm:text-xl">
              {p.label}
            </h3>
            <p className="mt-3 max-w-[240px] text-center text-[13px] font-light leading-relaxed text-white/85">
              {p.copy}
            </p>
            <span className="mt-5 border-b border-bronze-light/80 pb-1.5 font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">
              {p.cta}
            </span>
          </div>
        </button>
      ))}
    </section>
  );
}
